(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wolf-lifestyle-tiles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wolf-tiles]').forEach(function (row) {
    var pager = row.parentElement.querySelector('[data-wolf-tiles-pager]'); if (!pager) return;
    var fill = pager.querySelector('[data-wolf-tiles-fill]'), count = pager.querySelector('[data-wolf-tiles-count]'), n = row.children.length; if (!n) { pager.hidden = true; return; }
    function update() { var w = row.firstElementChild ? row.firstElementChild.getBoundingClientRect().width + 12 : 1; var i = Math.min(n, Math.round(row.scrollLeft / w) + 1); count.textContent = i + ' / ' + n; fill.style.transform = 'scaleX(' + (i / n) + ')'; }
    row.addEventListener('scroll', update, { passive: true }); update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wolf-pdp-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var strip = document.querySelector('.wtb');
    if (strip && 'IntersectionObserver' in window) {
      var links = Array.prototype.slice.call(strip.querySelectorAll('a[href^="#"]'));
      var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (!e.isIntersecting) return; links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + e.target.id); }); });
      }, { rootMargin: '-40% 0px -55% 0px' });
      targets.forEach(function (t) { if (t) io.observe(t); });
    }
    var specs = document.querySelector('[data-wolf-specs]');
    if (!specs) return;
    var body = specs.querySelector('[data-wolf-specs-body]'), btn = specs.querySelector('[data-wolf-specs-toggle]');
    var mq = window.matchMedia('(max-width: 760px)');
    function arm() {
      if (mq.matches && body.scrollHeight > 320) { specs.classList.add('wsp--collapsed'); btn.hidden = false; btn.setAttribute('aria-expanded', 'false'); }
      else { specs.classList.remove('wsp--collapsed'); btn.hidden = true; }
    }
    btn.addEventListener('click', function () { var open = specs.classList.toggle('wsp--open'); btn.setAttribute('aria-expanded', open ? 'true' : 'false'); if (open) btn.hidden = true; });
    arm(); mq.addEventListener ? mq.addEventListener('change', arm) : mq.addListener(arm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wolf-review-river"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wolf-river]').forEach(function (box) {
    var track = box.querySelector('[data-wolf-river-track]');
    var btn = box.parentElement.querySelector('[data-wolf-river-pause]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!track || reduce) return;
    if (btn) {
      btn.hidden = false;
      var play = btn.getAttribute('data-play-label') || 'Play reviews', pause = btn.querySelector('span').textContent;
      btn.addEventListener('click', function () {
        var paused = track.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.querySelector('span').textContent = paused ? play : pause;
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { entries.forEach(function (e) { track.classList.toggle('is-offscreen', !e.isIntersecting); }); }, { threshold: 0.05 }).observe(box);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wolf-review-wall"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rwl-filters]').forEach(function (root) {
    var sec = root.closest('section');
    var apply = function (f) {
      sec.querySelectorAll('[data-rwl-card]').forEach(function (c) { c.hidden = (f !== 'all' && c.getAttribute('data-tag').split('|').map(function (x) { return x.trim(); }).indexOf(f) === -1); });
      root.querySelectorAll('[data-rwl-filter]').forEach(function (b) { var on = b.getAttribute('data-rwl-filter') === f; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    };
    root.addEventListener('click', function (e) { var b = e.target.closest('[data-rwl-filter]'); if (b) apply(b.getAttribute('data-rwl-filter')); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wolf-story-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wolf-story]').forEach(function (box) {
    var video = box.querySelector('video'), btn = box.querySelector('[data-wolf-story-toggle]');
    if (!video || !btn || !box.dataset.src) return;
    var label = btn.querySelector('[data-wolf-story-label]'), icoPause = btn.querySelector('.wsv2__ico-pause'), icoPlay = btn.querySelector('.wsv2__ico-play');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var userPaused = reduce, loaded = false, onScreen = false;
    var setUi = function (paused) {
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? btn.dataset.playLabel : btn.dataset.pauseLabel);
      if (label) label.textContent = paused ? 'Play' : 'Pause';
      icoPause.hidden = paused; icoPlay.hidden = !paused;
    };
    var load = function () { if (loaded) return; loaded = true; video.src = box.dataset.src; video.load(); };
    var play = function () {
      load();
      var p = video.play();
      if (p && p.then) p.then(function () { box.classList.add('is-playing'); }).catch(function (err) { if (err && err.name === 'NotAllowedError') { userPaused = true; setUi(true); } }); // autoplay refused (Low Power Mode, Data Saver): offer Play; an AbortError from our own pause() is not a user pause
      else box.classList.add('is-playing');
    };
    var sync = function () { if (userPaused || !onScreen) { video.pause(); } else { play(); } };
    btn.hidden = false; setUi(userPaused);
    btn.addEventListener('click', function () { userPaused = !userPaused; setUi(userPaused); sync(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { entries.forEach(function (e) { onScreen = e.isIntersecting; sync(); }); }, { threshold: 0.2 }).observe(box);
    } else { onScreen = true; sync(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wolf-transformation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-wtx]'); if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var runway = root.querySelector('[data-wtx-runway]'), stage = root.querySelector('[data-wtx-stage]');
    var photos = [].slice.call(root.querySelectorAll('[data-wtx-photo]')), chapters = [].slice.call(root.querySelectorAll('[data-wtx-chapter]')), segs = [].slice.call(root.querySelectorAll('[data-wtx-seg]'));
    var scroller = root.querySelector('[data-wtx-chapters]');
    var n = chapters.length; if (!n) return;
    var desktop = window.matchMedia('(min-width: 761px)');
    var active = 0;
    var setActive = function (i) {
      if (i === active) return; active = i;
      photos.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
      chapters.forEach(function (c, k) { c.classList.toggle('is-active', k === i); c.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      segs.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    };
    var setFill = function (p) { segs.forEach(function (s, k) { var f = Math.max(0, Math.min(1, p * n - k)); s.firstElementChild.style.setProperty('--p', f); }); };
    if (reduce) { root.classList.add('wtx--static'); return; }
    root.classList.add('wtx--js');
    // Chapters are absolutely stacked on desktop; size the box to the tallest one so the CTA below never overlaps.
    var measure = function () {
      if (!desktop.matches || !scroller) { root.style.removeProperty('--wtx-ch-h'); return; }
      var h = 0; chapters.forEach(function (c) { var was = c.style.cssText; c.style.cssText = 'position:absolute;inset:auto 0;visibility:hidden;opacity:1;transform:none;transition:none'; h = Math.max(h, c.offsetHeight); c.style.cssText = was; });
      root.style.setProperty('--wtx-ch-h', h + 'px');
    };
    measure(); window.addEventListener('resize', measure); if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    // Desktop: scroll-driven. Progress = how far the runway has scrolled under the pinned stage (works for window or
    // Horizon's .page-wrapper scroll container because it reads the runway's viewport rect, not scrollY).
    var raf = 0;
    var update = function () {
      raf = 0;
      if (!desktop.matches) { mobileUpdate(); return; }
      var r = runway.getBoundingClientRect(); var range = r.height - stage.offsetHeight;
      var p = range > 0 ? Math.max(0, Math.min(1, -r.top / range)) : 0;
      setFill(p); setActive(Math.min(n - 1, Math.floor(p * n)));
    };
    var schedule = function () { if (!raf) raf = requestAnimationFrame(update); };
    document.addEventListener('scroll', schedule, { capture: true, passive: true });
    window.addEventListener('resize', schedule);
    // Phones: chapters stack under a sticky photo pane. The chapter whose top has passed a line 30% down the
    // space under the rail is the active one, so its title is always on screen when its photo fades in.
    var rail = root.querySelector('.wtx__rail');
    var mobileUpdate = function () {
      var rb = rail ? rail.getBoundingClientRect().bottom : 0; var T = rb + (window.innerHeight - rb) * 0.3; var i = 0, frac = 0;
      chapters.forEach(function (c, k) { var cr = c.getBoundingClientRect(); if (cr.top <= T) { i = k; frac = cr.height > 0 ? Math.max(0, Math.min(1, (T - cr.top) / cr.height)) : 0; } });
      setActive(i); setFill((i + frac) / n);
    };
    // Rail buttons: jump to that chapter (scroll the runway on desktop, the row on mobile).
    segs.forEach(function (s, k) { s.addEventListener('click', function () {
      if (desktop.matches) {
        var r = runway.getBoundingClientRect(); var range = r.height - stage.offsetHeight; var target = (k + 0.5) / n * range;
        var sc = runway.closest('.page-wrapper') || document.scrollingElement || document.documentElement;
        var current = sc === document.scrollingElement || sc === document.documentElement ? window.scrollY : sc.scrollTop;
        var top = current + r.top + target;
        if (sc.scrollTo) sc.scrollTo({ top: top, behavior: 'smooth' }); else window.scrollTo(0, top);
      } else { chapters[k].scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }); });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wolf-ugc-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.wug').forEach(function (sec) {
    var vp = sec.querySelector('[data-wug]'); if (!vp) return;
    var step = function () { var it = vp.querySelector('.wug__item'); return it ? it.getBoundingClientRect().width + 12 : 320; };
    var prev = sec.querySelector('[data-wug-prev]'), next = sec.querySelector('[data-wug-next]');
    if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { vp.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();
})();
